import { GET_ORDER_BILLING_INFO } from '../actionTypes/OrderActionTypes';

export const getOrderBillingInfo = (payload) => ({
    type: GET_ORDER_BILLING_INFO,
    payload,
});

export default getOrderBillingInfo;
